import React from 'react'
import { createContext } from 'lib/createContext'
import { Loading, Message } from '@workwhile/ui'
import { useRuleQuery } from 'queries/wage/useRuleQuery'
import { useJurisdictionsQuery } from 'queries/wage/useJurisdictionsQuery'

type RuleDetailContextState = {
  state: NonNullable<ReturnType<typeof useRuleQuery>['data']> & {
    jurisdictions: NonNullable<ReturnType<typeof useJurisdictionsQuery>['data']>
  }
  actions: Record<string, never>
}

const [Context, useRuleDetailContextValue] =
  createContext<RuleDetailContextState>({
    name: 'RuleDetailContext',
  })

export const RuleDetailProvider = ({
  ruleId,
  children,
}: {
  ruleId: number
  children: React.ReactNode
}) => {
  const { data, isLoading, isError } = useRuleQuery(ruleId)
  const { data: jurisdictions } = useJurisdictionsQuery()

  if (isLoading) {
    return <Loading />
  }

  if (isError) {
    return (
      <Message variant="error">
        Sorry, something went wrong. Please reach out to eng support if this
        persists.
      </Message>
    )
  }

  if (!data) {
    return null
  }

  const value: RuleDetailContextState = {
    state: { ...data, jurisdictions: jurisdictions ?? [] },
    actions: {},
  }

  return <Context.Provider value={value}>{children}</Context.Provider>
}

export { useRuleDetailContextValue }
